import { CountReturnTypes } from 'api/utils/queries';
import { Payor, Provider, Site, Status, Remittance, Tariff } from 'interfaces';
import { useClaimPaginationStore } from 'store/ClaimPaginationStore';
import { mockClaims } from 'test-fixtures/mocks/frontend';

export const useTutorialClaimManagementData = () => {
  const { pagination, setPagination } = useClaimPaginationStore();
  const mockPaginatedClaimsResult = {
    data: {
      data: mockClaims,
      total: 0,
      nextPage: 0,
      invalidData: [] as string[], //TODO: add invalidData to mockClaims and add to tour
      totalAmountSubmitted: 0,
      totalAmountPaid: 0,
      totalAmountOutstanding: 0,
    },
    refetch: () => {},
  };

  const claimStatusesCountResult = {
    data: {
      Paid: 25,
      Ready: 30,
      Submitted: 2000,
      Error: 5,
    } as CountReturnTypes,
    refetch: () => {},
  };

  const providersResult = {
    data: [] as Provider[],
    refetch: () => {},
  };

  const sitesResult = {
    data: [] as Site[],
    refetch: () => {},
  };

  const statusesResult = {
    data: [] as Status[],
    refetch: () => {},
  };
  const payorsResult = {
    data: [] as Payor[],
    refetch: () => {},
  };

  const remittanceResult = {
    data: [] as Remittance[],
    refetch: () => {},
  };
  const tariffResult = {
    data: [] as Tariff[],
    refetch: () => {},
  };

  const isLoading = false;
  const isFetching = false;
  const isError = false;
  const errorMessage = '';

  return {
    claims: {
      data: mockPaginatedClaimsResult.data?.data || [],
      total: mockPaginatedClaimsResult.data?.total || 0,
      nextPage: mockPaginatedClaimsResult.data?.nextPage || 0,
      invalidData: mockPaginatedClaimsResult.data?.invalidData || [],
      totalAmountSubmitted:
        mockPaginatedClaimsResult.data?.totalAmountSubmitted || 0,
      totalAmountPaid: mockPaginatedClaimsResult.data?.totalAmountPaid || 0,
      totalAmountOutstanding:
        mockPaginatedClaimsResult.data?.totalAmountOutstanding || 0,
    },
    claimStatusesCount: claimStatusesCountResult.data,
    providers: providersResult.data || [],
    sites: sitesResult.data || [],
    status: statusesResult.data || [],
    payors: payorsResult.data || [],
    remittances: remittanceResult.data || [],
    tariffs: tariffResult.data || [],
    isLoading,
    isError,
    isFetching,
    errorMessage,
    invalidData: mockPaginatedClaimsResult.data?.invalidData,
    pagination,
    setPagination,
    refetchClaims: mockPaginatedClaimsResult.refetch,
    refetchStatusesCount: claimStatusesCountResult.refetch,
  };
};
